import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ApiService } from '../Services/api.service';
import { AuthService } from '../Services/auth.service';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material';
import { ToastService } from '../Services/toast.service';
import { LazyLoadEvent } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';

interface TOB {
  srNo: number;
  providerMedicalService: string;
  coInsurance: string;
  limit: string;
  startDate: string;
  times: number;
  notAllowed: string;
  accountName?: string; 
}

@Component({
  selector: 'app-tob',
  standalone: true,
  imports: [ButtonModule, TableModule, CommonModule, InputTextModule, TranslateModule, FormsModule, MaterialModule, PaginatorModule],
  providers: [ApiService, AuthService, ToastService, TranslateService],
  templateUrl: './tob.component.html',
  styleUrl: './tob.component.css'
})
export class TobComponent implements OnInit {
    @ViewChild('searchInput') searchInput!: ElementRef;
  loading: boolean = false;
  assuredID: string = '';
  medicalServices: TOB[] = [];
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  noDataAvailable:boolean | false;
  constructor(
    private apiService: ApiService<TOB[]>,
    private authService: AuthService,
    private toastService: ToastService,
    private cdr:ChangeDetectorRef,
    private translateService:TranslateService
  ) {}

  ngOnInit(): void {
  }

  fetchTOBData(page: number, size: number): void {
    if (!this.assuredID) {
      this.translateService.get('toast.pleaseenterassuredid').subscribe(text => this.toastService.showWarn(text));
      return;
    }

    this.loading = true;
    const providerId = this.authService.getCurrentUserPID();
    const endpoint = `api/Limit/GetTableOfBenifits?assuredID=${this.assuredID}&providerId=${providerId}&pageSize=${size}&pageNumber=${page}`;
    
    this.apiService.getAll(endpoint).subscribe({
      next: (response: any) => {
        this.medicalServices = this.transformData(response);
        this.totalRecords = response.totalCount || 0;
        this.loading = false;
        if (response.isRequestSuccessful === false) {
          this.translateService.get('toast.nodataavailable').subscribe(text => this.toastService.showInfo(text));
          this.assuredID ='';
          this.noDataAvailable = true;
          return;
        }
        this.cdr.detectChanges(); 
        this.noDataAvailable = false;
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        this.medicalServices = [];
        this.totalRecords = 0;
        this.toastService.showError(error);
        this.cdr.detectChanges();
      }
    });
  }

  transformData(response: any): TOB[] {
    if (response?.successResponse && Array.isArray(response.successResponse)) {
      return response.successResponse.map((item: any, index: number) => ({
        srNo: ((this.pageNumber - 1) * this.pageSize) + index + 1,
        accountName: item.accntNam || '-',
        providerMedicalService: item.providerMedicalService || '-',
        coInsurance: item.coInsurance || '-',
        limit: item.limit?.trim() || '-',
        startDate: item.startDate || '-',
        times: item.times || 0,
        notAllowed: item.notAllowed || '-'
      }));
    }
    return [];
  }

  onLazyLoad(event: LazyLoadEvent): void {
    const newPageSize = event.rows || this.pageSize;
    const newPageNumber = (event.first !== undefined && event.rows) 
      ? Math.floor(event.first / event.rows) + 1 
      : this.pageNumber;

    this.pageNumber = newPageNumber;
    this.pageSize = newPageSize;
    this.first = event.first || 0;
    this.fetchTOBData(this.pageNumber, this.pageSize);
  }

  onSearch(): void {
    this.first = 0;
    this.pageNumber = 1;
    this.fetchTOBData(this.pageNumber, this.pageSize);
  }

  ngAfterViewInit() {
    this.searchInput.nativeElement.focus();
  }
}